import { Coupon } from "sdk/promoCodes";

export const referAFriendMockCoupon = {
  duration_in_months: 1,
  percent_off: 10,
} as Coupon;
